/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import Lottie from "react-lottie";
import ConstantObj from "Static/constant";
import Rocket from "Utils/LottieFiles/Rocket.json";
import onboarding from "../common/Onboarding";

const totalSteps = ConstantObj.onBoardingTotalSteps;

const OnBoardStepPopupHeader = (props = {}) => {
  const { remainingCount = 0 } = props || {};

  return (
    <div className="popupHeader">
      <div className="leftSection">
        <div className="headerText">
          {`Your progress: ${totalSteps - remainingCount}/${totalSteps} Steps`}
        </div>
        <CompletedStatus {...props} />
      </div>
    </div>
  );
};

const CompletedStatus = (props = {}) => {
  const { remainingCount = 0 } = props || {};
  const [remainingCountProgress, setRemainingCountProgress] =
    useState(remainingCount);
  const [completedPercentage, setCompletedPercentage] = useState(0);

  const getPercentageCompleted = () => {
    if (remainingCountProgress != null && totalSteps) {
      setTimeout(() => {
        const completedCount = totalSteps - remainingCountProgress;
        const percentageForOneStep = 100 / totalSteps;
        setCompletedPercentage(
          (completedCount * percentageForOneStep).toFixed(0)
        );
      }, 10);
    }
  };

  useEffect(() => {
    setRemainingCountProgress(onboarding?.remainingFeatureCount);
  }, [onboarding?.remainingFeatureCount]);

  useEffect(() => {
    getPercentageCompleted();
  }, [remainingCountProgress]);

  return (
    <div className="completedStatus">
      <div className="statusBar">
        <div className="progress">
          <span
            className="progress-value progressAnimationStrike"
            style={{ width: `${completedPercentage}%` }}
          ></span>
        </div>
      </div>
      <div className="statusCompletedText">
        {completedPercentage}% Complete. Keep It Going!
      </div>
    </div>
  );
};

const HeaderIcon = (props = {}) => {
  const {
    width = "60",
    height = "79",
    style = { margin: "0 auto" }
  } = props || {};

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: Rocket,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  return (
    <Lottie
      options={defaultOptions}
      width={width}
      height={height}
      style={style}
      speed={0.1}
    />
  );
};

export { OnBoardStepPopupHeader, HeaderIcon };
export default OnBoardStepPopupHeader;
